// import {
//   CalendarDays,
//   MoveLeft,
//   MoveRight,
//   Phone,
//   Tag,
//   User,
// } from "lucide-react";
// import Navbar from "../../Components/Navbar";
// import { images } from "../../assets/assets";
// import { Link, useParams } from "react-router-dom";
// import Footer from "../../Components/Footer";
// import { getImageUrl } from "../../utils/getImageUrl";
// import LexicalReadOnly from "../../utils/LexicalReadOnly";
// import { updateSEO } from "../../utils/seo";
// import { useState, useEffect } from "react";
// import { getBlogSlug } from "../../api";

// // Format date from createdAt to "Dec 8, 2024" format
// const formatDate = (dateString) => {
//   const date = new Date(dateString);
//   return date.toLocaleDateString("en-US", {
//     year: "numeric",
//     month: "short",
//     day: "numeric",
//   });
// };

// // Skeleton Loading Component
// const BlogDetailSkeleton = () => (
//   <div className="animate-pulse">
//     <div className="flex gap-2 mb-4">
//       <div className="h-8 bg-gray-300 rounded-full w-24" />
//       <div className="h-8 bg-gray-300 rounded-full w-32" />
//     </div>
//     <div className="h-10 bg-gray-300 rounded mb-4 w-3/4" />
//     <div className="flex gap-3 mb-6">
//       <div className="w-16 h-16 bg-gray-300 rounded-full" />
//       <div className="flex-1">
//         <div className="h-5 bg-gray-300 rounded mb-2 w-40" />
//         <div className="h-4 bg-gray-300 rounded w-56" />
//       </div>
//     </div>
//     <div className="h-80 bg-gray-300 rounded-lg mb-4" />
//     <div className="h-32 bg-gray-300 rounded mb-4" />
//     <div className="space-y-3">
//       <div className="h-4 bg-gray-300 rounded w-full" />
//       <div className="h-4 bg-gray-300 rounded w-full" />
//       <div className="h-4 bg-gray-300 rounded w-3/4" />
//     </div>
//   </div>
// );

// const BlogDetail = () => {
//   const { slug } = useParams();
//   const [BlogData, setBlogData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchBlogDetail = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const response = await getBlogSlug(slug);
//         setBlogData(response?.data || response);
//       } catch (err) {
//         setError("Failed to load blog details. Please try again later.");
//         console.error("Error fetching blog:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (slug) {
//       fetchBlogDetail();
//     }
//   }, [slug]);

//   useEffect(() => {
//     if (BlogData) {
//       updateSEO({
//         title: BlogData.seoTitle || `${BlogData.heading} | Dev Rishi Hospital`,
//         description: BlogData.metaDescription || BlogData.blogSmallDesc,
//         keywords: BlogData.metaKeywords || ""
//       });
//     }
//   }, [BlogData]);

//   if (error) {
//     return (
//       <div className="font-lato">
//         <Navbar />
//         <div className="px-4 sm:px-6 md:px-8 lg:px-11 py-12">
//           <div className="text-center">
//             <p className="text-red-500 font-poppins font-semibold text-[16px] mb-4">
//               {error}
//             </p>
//             <button
//               onClick={() => window.location.reload()}
//               className="bg-[#1975FF] text-white px-6 py-2 rounded-[10px] hover:bg-[#1560d4] transition-all"
//             >
//               Retry
//             </button>
//           </div>
//         </div>
//         <Footer />
//       </div>
//     );
//   }

//   if (loading || !BlogData) {
//     return (
//       <div className="font-lato">
//         <Navbar />
//         <div className="px-4 sm:px-6 md:px-8 lg:px-11 py-6">
//           <BlogDetailSkeleton />
//         </div>
//         <Footer />
//       </div>
//     );
//   }

//   const url = window.location.href;
//   const title = document.title;

//   return (
//     <div className="font-lato">
//       <Navbar />
//       <div className="px-4 sm:px-6 md:px-8 lg:px-11">
//         <Link to={"/blog"}>
//           <button className="flex gap-2 items-center text-gray-700 hover:text-black active:text-gray-900 transition-colors duration-200 group">
//             <MoveLeft className="w-4 h-4 mt-0.5 group-hover:translate-x-[-2px] transition-transform duration-200" />
//             <p className="text-sm sm:text-base hover:underline">
//               Back to Articles
//             </p>
//           </button>
//         </Link>
//         <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-5">
//           <p className="font-poppins font-medium text-[13px] sm:text-[15px] bg-[#D4AF37] hover:bg-[#C4A027] active:bg-[#B49017] py-1.5 px-4 rounded-[18px] text-white transition-colors duration-200 cursor-pointer">
//             {BlogData.category}
//           </p>
//           <div className="flex items-center gap-1 hover:opacity-80 transition-opacity duration-200">
//             <CalendarDays
//               color="#000"
//               className="w-4 sm:w-[16px] h-4 sm:h-[16px]"
//             />
//             <p className="text-black font-poppins font-medium text-sm sm:text-base">
//               {formatDate(BlogData?.createdAt)}
//             </p>
//           </div>
//         </div>
//         <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-[38px] text-black leading-[1.2] font-bold mt-2">
//           {BlogData?.heading}
//         </h1>
//         <div className="flex items-center gap-2 my-3 hover:opacity-90 transition-opacity duration-200">
//           {/* person icon */}
//           <span className="p-2 bg-[#D9D9D9] rounded-full hover:bg-[#C9C9C9] active:bg-[#B9B9B9] transition-colors duration-200">
//             <User color="#000" className="w-4 sm:w-5 h-4 sm:h-5" />
//           </span>
//           <div>
//             <p className="text-base sm:text-[18px] font-bold">
//               {BlogData?.author?.name}
//             </p>
//             <p className="text-sm sm:text-base font-medium text-gray-700">
//               {BlogData?.author?.designationHeading}, Dev Rishi Hospital
//             </p>
//           </div>
//         </div>
//         <div className="px-0 sm:px-6 md:px-12 lg:px-28">
//           <img
//             src={getImageUrl(BlogData?.imagePath)}
//             alt="blog-image"
//             className="w-full h-48 sm:h-64 md:h-80 lg:h-[350px] rounded-[20px] border border-[#A4A4A4] bg-cover hover:shadow-lg transition-shadow duration-300"
//           />
//           <div className="border-l-4 sm:border-l-6 border-[#D4AF37] px-4 sm:px-6 md:px-8 py-3 italic text-lg sm:text-xl md:text-2xl font-medium my-4 bg-gray-50 hover:bg-gray-100 transition-colors duration-200 rounded-r-lg">
//             {`"${BlogData?.blogSmallDesc}"`}
//           </div>
//           {/* desc */}
//           <div className=" my-4">
//             <div className="prose-blog">
//               <LexicalReadOnly value={BlogData?.blogFullDesc} />
//             </div>
//             <div className="bg-[#F7F7F7B2] hover:bg-[#EFEFEF] active:bg-[#E7E7E7] rounded-[10px] px-4 sm:px-6 py-3 my-4 flex flex-col sm:flex-row gap-3 sm:gap-2 items-start sm:items-center justify-between transition-colors duration-200">
//               <div className="flex items-start sm:items-center gap-3 sm:gap-4 flex-1 w-full sm:w-auto">
//                 <Tag
//                   color="#1975FF"
//                   className="w-5 sm:w-[25px] h-5 sm:h-[25px] flex-shrink-0 mt-1 sm:mt-0"
//                 />
//                 <div className="flex gap-2 flex-wrap items-center">
//                   {BlogData.tags.map((tag, idx) => (
//                     <p
//                       key={idx}
//                       className="py-1.5 px-2.5 border border-gray-300 hover:border-[#1975FF] hover:bg-blue-50 active:bg-blue-100 active:border-[#1560d4] rounded-[5px] text-xs sm:text-[14px] font-medium transition-all duration-200 cursor-pointer"
//                     >
//                       {tag}
//                     </p>
//                   ))}
//                 </div>
//               </div>
//               <div className="flex gap-2 sm:gap-3 items-center w-full sm:w-auto">
//                 <p className="text-base sm:text-[18px] font-openSans font-bold whitespace-nowrap">
//                   Share:
//                 </p>
//                 <div className="flex gap-2">
//                   <button className="p-2 hover:bg-gray-200 active:bg-gray-300 rounded-lg transition-colors duration-200 hover:scale-110 active:scale-95 duration-200">
//                     <a target="_blank" href="https://www.instagram.com/">
//                       <img
//                         src={images.InstaShare}
//                         alt="instashare"
//                         className="w-5 sm:w-6 h-5 sm:h-6"
//                         loading="lazy"
//                       />
//                     </a>
//                   </button>
//                   <button className="p-2 hover:bg-gray-200 active:bg-gray-300 rounded-lg transition-colors duration-200 hover:scale-110 active:scale-95 duration-200">
//                     <a
//                       target="_blank"
//                       href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`}
//                     >
//                       <img
//                         src={images.TwitterShare}
//                         alt="twittershare"
//                         className="w-5 sm:w-6 h-5 sm:h-6"
//                         loading="lazy"
//                       />
//                     </a>
//                   </button>
//                   <button className="p-2 hover:bg-gray-200 active:bg-gray-300 rounded-lg transition-colors duration-200 hover:scale-110 active:scale-95 duration-200">
//                     <a
//                       target="_blank"
//                       href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
//                     >
//                       <img
//                         src={images.FacebookShare}
//                         alt="facebookshare"
//                         className="w-5 sm:w-6 h-5 sm:h-6"
//                         loading="lazy"
//                       />
//                     </a>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Written By */}
//         <div className="flex flex-col sm:flex-row gap-4 sm:gap-3 items-center sm:items-start max-w-[750px] mx-auto my-6 p-4 sm:p-6 hover:bg-gray-50 rounded-lg transition-colors duration-200">
//           <img
//             src={getImageUrl(BlogData?.author?.imagePath)}
//             alt="doctor-img"
//             className="w-32 sm:w-[150px] h-32 sm:h-[150px] object-cover rounded-full hover:shadow-lg transition-shadow duration-300 flex-shrink-0"
//           />
//           <div className="flex-1 text-center sm:text-left">
//             <p className="text-xl sm:text-2xl font-bold text-black">
//               Written by {BlogData?.author?.name}
//             </p>
//             <p className="text-sm sm:text-[15px] font-medium text-gray-700 line-clamp-2 mt-1">
//               {BlogData?.author?.doctorDescription[0]}
//             </p>
//             <Link to={`/doctor-detail/${BlogData?.author?.slug}`}>
//               {" "}
//               <button className="text-sm sm:text-[15px] text-[#1975FF] font-semibold flex gap-2 items-center mt-2 hover:text-[#1560d4] active:text-[#1050b8] transition-colors duration-200 group mx-auto sm:mx-0 hover:gap-3">
//                 View Doctor Profiles
//                 <MoveRight className="w-4 sm:w-5 h-4 sm:h-5 group-hover:translate-x-1 transition-transform duration-200" />
//               </button>
//             </Link>
//           </div>
//         </div>
//       </div>
//       {/* cta */}
//       <div className="py-10 md:py-14 bg-[#F7F7F7B2]    transition-all duration-500   hover:bg-[#F0EBFFB2] border border-transparent hover:border-white my-10 md:my-12">
//         <h1 className="max-w-[550px] text-center text-[22px] sm:text-[26px] md:text-[28px] lg:text-[32px] font-semibold mx-auto leading-[1.3]">
//           Have Health Questions?
//         </h1>
//         <p className="max-w-[375px] font-openSans text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] mx-auto text-center mt-3">
//           Consult with our expert doctors for personalized medical advice.
//         </p>
//         <div className="flex flex-wrap gap-4 justify-center mt-8">
//           <Link
//             to="/appointment"
//             className="bg-[#1975FF] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] font-semibold text-white hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group"
//           >
//             <Phone color="#fff" className=" w-5 h-5" />
//             Book a Consultation Today{" "}
//             <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
//               <MoveRight color="#000" className="rotate-[-38deg] w-4 h-4" />
//             </span>
//           </Link>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default BlogDetail;



import {
  CalendarDays,
  MoveLeft,
  MoveRight,
  Phone,
  Tag,
  User,
} from "lucide-react";
import Navbar from "../../Components/Navbar";
import { images } from "../../assets/assets";
import { Link, useParams } from "react-router-dom";
import Footer from "../../Components/Footer";
import { getImageUrl } from "../../utils/getImageUrl";
import LexicalReadOnly from "../../utils/LexicalReadOnly";
import SEOHead from "../../Components/SEOHead";
import { useState, useEffect, useContext } from "react";
import { getBlogSlug } from "../../api";
import { InitialDataContext } from "../../context/InitialDataContext";

// Format date from createdAt to "Dec 8, 2024" format
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// Skeleton Loading Component
const BlogDetailSkeleton = () => (
  <div className="animate-pulse">
    <div className="flex gap-2 mb-4">
      <div className="h-8 bg-gray-300 rounded-full w-24" />
      <div className="h-8 bg-gray-300 rounded-full w-32" />
    </div>
    <div className="h-10 bg-gray-300 rounded mb-4 w-3/4" />
    <div className="flex gap-3 mb-6">
      <div className="w-16 h-16 bg-gray-300 rounded-full" />
      <div className="flex-1">
        <div className="h-5 bg-gray-300 rounded mb-2 w-40" />
        <div className="h-4 bg-gray-300 rounded w-56" />
      </div>
    </div>
    <div className="h-80 bg-gray-300 rounded-lg mb-4" />
    <div className="h-32 bg-gray-300 rounded mb-4" />
    <div className="space-y-3">
      <div className="h-4 bg-gray-300 rounded w-full" />
      <div className="h-4 bg-gray-300 rounded w-full" />
      <div className="h-4 bg-gray-300 rounded w-3/4" />
    </div>
  </div>
);

const BlogDetail = () => {
  const { slug } = useParams();
  const ssrData = useContext(InitialDataContext);
  const [BlogData, setBlogData] = useState(ssrData?.data || null);
  const [loading, setLoading] = useState(!ssrData?.data);
  const [error, setError] = useState(null);

  // SSR-safe: window/document sirf client par exist karte hain,
  // isliye ye state useEffect me hi set hogi (server par empty string rahegi)
  const [shareUrl, setShareUrl] = useState("");
  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    setShareUrl(window.location.href);
    setPageTitle(document.title);
  }, [BlogData]);

  useEffect(() => {
    if (ssrData?.data && ssrData.data.slug === slug) {
      setBlogData(ssrData.data);
      setLoading(false);
      return;
    }

    const fetchBlogDetail = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getBlogSlug(slug);
        setBlogData(response?.data || response);
      } catch (err) {
        setError("Failed to load blog details. Please try again later.");
        console.error("Error fetching blog:", err);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchBlogDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const seoProps = {
    title: BlogData?.seoTitle || (BlogData?.heading ? `${BlogData.heading} | Dev Rishi Hospital` : undefined),
    description: BlogData?.metaDescription || BlogData?.blogSmallDesc,
    keywords: BlogData?.metaKeywords,
    url: slug ? `https://devrishihospital.com/blog-detail/${slug}` : undefined,
    schema: BlogData?.heading ? {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "headline": BlogData.heading,
      "description": BlogData.blogSmallDesc || BlogData.metaDescription,
      "datePublished": BlogData.createdAt,
      "dateModified": BlogData.updatedAt,
      "url": slug ? `https://devrishihospital.com/blog-detail/${slug}` : undefined
    } : null,
  };

  if (error) {
    return (
      <div className="font-lato">
        <SEOHead {...seoProps} />
        <Navbar />
        <div className="px-4 sm:px-6 md:px-8 lg:px-11 py-12">
          <div className="text-center">
            <p className="text-red-500 font-poppins font-semibold text-[16px] mb-4">
              {error}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-[#1975FF] text-white px-6 py-2 rounded-[10px] hover:bg-[#1560d4] transition-all"
            >
              Retry
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (loading || !BlogData) {
    return (
      <div className="font-lato">
        <SEOHead {...seoProps} />
        <Navbar />
        <div className="px-4 sm:px-6 md:px-8 lg:px-11 py-6">
          <BlogDetailSkeleton />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="font-lato">
      <SEOHead {...seoProps} />
      <Navbar />
      <div className="px-4 sm:px-6 md:px-8 lg:px-11">
        <Link to={"/blog"}>
          <button className="flex gap-2 items-center text-gray-700 hover:text-black active:text-gray-900 transition-colors duration-200 group">
            <MoveLeft className="w-4 h-4 mt-0.5 group-hover:translate-x-[-2px] transition-transform duration-200" />
            <p className="text-sm sm:text-base hover:underline">
              Back to Articles
            </p>
          </button>
        </Link>
        <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-5">
          <p className="font-poppins font-medium text-[13px] sm:text-[15px] bg-[#D4AF37] hover:bg-[#C4A027] active:bg-[#B49017] py-1.5 px-4 rounded-[18px] text-white transition-colors duration-200 cursor-pointer">
            {BlogData.category}
          </p>
          <div className="flex items-center gap-1 hover:opacity-80 transition-opacity duration-200">
            <CalendarDays
              color="#000"
              className="w-4 sm:w-[16px] h-4 sm:h-[16px]"
            />
            <p className="text-black font-poppins font-medium text-sm sm:text-base">
              {formatDate(BlogData?.createdAt)}
            </p>
          </div>
        </div>
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-[38px] text-black leading-[1.2] font-bold mt-2">
          {BlogData?.heading}
        </h1>
        <div className="flex items-center gap-2 my-3 hover:opacity-90 transition-opacity duration-200">
          {/* person icon */}
          <span className="p-2 bg-[#D9D9D9] rounded-full hover:bg-[#C9C9C9] active:bg-[#B9B9B9] transition-colors duration-200">
            <User color="#000" className="w-4 sm:w-5 h-4 sm:h-5" />
          </span>
          <div>
            <p className="text-base sm:text-[18px] font-bold">
              {BlogData?.author?.name}
            </p>
            <p className="text-sm sm:text-base font-medium text-gray-700">
              {BlogData?.author?.designationHeading}, Dev Rishi Hospital
            </p>
          </div>
        </div>
        <div className="px-0 sm:px-6 md:px-12 lg:px-28">
          <img
            src={getImageUrl(BlogData?.imagePath)}
            alt="blog-image"
            className="w-full h-48 sm:h-64 md:h-80 lg:h-[350px] rounded-[20px] border border-[#A4A4A4] bg-cover hover:shadow-lg transition-shadow duration-300"
          />
          <div className="border-l-4 sm:border-l-6 border-[#D4AF37] px-4 sm:px-6 md:px-8 py-3 italic text-lg sm:text-xl md:text-2xl font-medium my-4 bg-gray-50 hover:bg-gray-100 transition-colors duration-200 rounded-r-lg">
            {`"${BlogData?.blogSmallDesc}"`}
          </div>
          {/* desc */}
          <div className=" my-4">
            <div className="prose-blog">
              <LexicalReadOnly value={BlogData?.blogFullDesc} />
            </div>
            <div className="bg-[#F7F7F7B2] hover:bg-[#EFEFEF] active:bg-[#E7E7E7] rounded-[10px] px-4 sm:px-6 py-3 my-4 flex flex-col sm:flex-row gap-3 sm:gap-2 items-start sm:items-center justify-between transition-colors duration-200">
              <div className="flex items-start sm:items-center gap-3 sm:gap-4 flex-1 w-full sm:w-auto">
                <Tag
                  color="#1975FF"
                  className="w-5 sm:w-[25px] h-5 sm:h-[25px] flex-shrink-0 mt-1 sm:mt-0"
                />
                <div className="flex gap-2 flex-wrap items-center">
                  {Array.isArray(BlogData?.tags) && BlogData.tags.map((tag, idx) => (
                    <p
                      key={idx}
                      className="py-1.5 px-2.5 border border-gray-300 hover:border-[#1975FF] hover:bg-blue-50 active:bg-blue-100 active:border-[#1560d4] rounded-[5px] text-xs sm:text-[14px] font-medium transition-all duration-200 cursor-pointer"
                    >
                      {tag}
                    </p>
                  ))}
                </div>
              </div>
              <div className="flex gap-2 sm:gap-3 items-center w-full sm:w-auto">
                <p className="text-base sm:text-[18px] font-openSans font-bold whitespace-nowrap">
                  Share:
                </p>
                <div className="flex gap-2">
                  <button className="p-2 hover:bg-gray-200 active:bg-gray-300 rounded-lg transition-colors duration-200 hover:scale-110 active:scale-95 duration-200">
                    <a target="_blank" href="https://www.instagram.com/">
                      <img
                        src={images.InstaShare}
                        alt="instashare"
                        className="w-5 sm:w-6 h-5 sm:h-6"
                        loading="lazy"
                      />
                    </a>
                  </button>
                  <button className="p-2 hover:bg-gray-200 active:bg-gray-300 rounded-lg transition-colors duration-200 hover:scale-110 active:scale-95 duration-200">
                    <a
                      target="_blank"
                      href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(pageTitle)}`}
                    >
                      <img
                        src={images.TwitterShare}
                        alt="twittershare"
                        className="w-5 sm:w-6 h-5 sm:h-6"
                        loading="lazy"
                      />
                    </a>
                  </button>
                  <button className="p-2 hover:bg-gray-200 active:bg-gray-300 rounded-lg transition-colors duration-200 hover:scale-110 active:scale-95 duration-200">
                    <a
                      target="_blank"
                      href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                    >
                      <img
                        src={images.FacebookShare}
                        alt="facebookshare"
                        className="w-5 sm:w-6 h-5 sm:h-6"
                        loading="lazy"
                      />
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
       
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-3 items-center sm:items-start max-w-[750px] mx-auto my-6 p-4 sm:p-6 hover:bg-gray-50 rounded-lg transition-colors duration-200">
          <img
            src={getImageUrl(BlogData?.author?.imagePath)}
            alt="doctor-img"
            className="w-32 sm:w-[150px] h-32 sm:h-[150px] object-cover rounded-full hover:shadow-lg transition-shadow duration-300 flex-shrink-0"
          />
          <div className="flex-1 text-center sm:text-left">
            <p className="text-xl sm:text-2xl font-bold text-black">
              Written by {BlogData?.author?.name}
            </p>
            <p className="text-sm sm:text-[15px] font-medium text-gray-700 line-clamp-2 mt-1">
              {Array.isArray(BlogData?.author?.doctorDescription) ? BlogData.author.doctorDescription[0] : (typeof BlogData?.author?.doctorDescription === 'string' ? BlogData.author.doctorDescription : "")}
            </p>
            <Link to={`/doctor-detail/${BlogData?.author?.slug}`}>
              {" "}
              <button className="text-sm sm:text-[15px] text-[#1975FF] font-semibold flex gap-2 items-center mt-2 hover:text-[#1560d4] active:text-[#1050b8] transition-colors duration-200 group mx-auto sm:mx-0 hover:gap-3">
                View Doctor Profiles
                <MoveRight className="w-4 sm:w-5 h-4 sm:h-5 group-hover:translate-x-1 transition-transform duration-200" />
              </button>
            </Link>
          </div>
        </div>
      </div>
  
      <div className="py-10 md:py-14 bg-[#F7F7F7B2]    transition-all duration-500   hover:bg-[#F0EBFFB2] border border-transparent hover:border-white my-10 md:my-12">
        <h1 className="max-w-[550px] text-center text-[22px] sm:text-[26px] md:text-[28px] lg:text-[32px] font-semibold mx-auto leading-[1.3]">
          Have Health Questions?
        </h1>
        <p className="max-w-[375px] font-openSans text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] mx-auto text-center mt-3">
          Consult with our expert doctors for personalized medical advice.
        </p>
        <div className="flex flex-wrap gap-4 justify-center mt-8">
          <Link
            to="/appointment"
            className="bg-[#1975FF] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] font-semibold text-white hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group"
          >
            <Phone color="#fff" className=" w-5 h-5" />
            Book a Consultation Today{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight color="#000" className="rotate-[-38deg] w-4 h-4" />
            </span>
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetail;
